const publicationsConfig = [
  {
    id: 'pub-1', year: '2024', type: 'Journal article',
    title: 'Multilayer analysis of energy networks',
    authors: 'Muhammad Kazim, Harun Pirim, Shuangqing Shi, and Da Wu',
    venue: 'Sustainable Energy, Grids and Networks, 39, 101407',
    url: 'https://doi.org/10.1016/j.segan.2024.101407',
  },
  {
    id: 'pub-2', year: '2025', type: 'Journal article',
    title: 'Analysis of multilayer energy networks: A comprehensive literature review',
    authors: 'Muhammad Kazim, Harun Pirim, Om Prakash Yadav, Cong Le, and Thuy Le',
    venue: 'Applied Energy, 398, 126357',
    url: 'https://doi.org/10.1016/j.apenergy.2025.126357',
  },
  {
    id: 'pub-3', year: '2025', type: 'Journal article',
    title: 'Multilayer GNN for Predictive Maintenance and Clustering in Power Grids',
    authors: 'Muhammad Kazim, Harun Pirim, Cong Le, Thuy Le, and Om Prakash Yadav',
    venue: 'iScience',
    url: 'https://www.cell.com/iscience/home',
  },
  {
    id: 'pub-4', year: '2025', type: 'Journal article',
    title: 'Edge-level explainable graph neural networks with network-centric features for transmission line failure prediction in power grids',
    authors: 'Muhammad Kazim, Harun Pirim, Om Prakash Yadav, Cong Le, and Thuy Le',
    venue: 'Sustainable Energy, Grids and Networks',
    url: 'https://doi.org/10.1016/j.segan.2025.101969',
  },
  {
    id: 'pub-5', year: '2025', type: 'Journal article',
    title: 'Deepfake Image Forensics for Privacy Protection and Authenticity Using Deep Learning',
    authors: 'Sohail, S., Sajjad, S. M., Zafar, A., Iqbal, Z., Muhammad, Z., and Muhammad Kazim',
    venue: 'Information, 16(4), 270',
    url: 'https://doi.org/10.3390/info16040270',
  },
  {
    id: 'pub-6', year: '2024', type: 'Journal article',
    title: 'Analyzing Tor Browser Artifacts for Enhanced Web Forensics, Anonymity, Cybersecurity, and Privacy in Windows-Based Systems',
    authors: 'Javed, M. S., Sajjad, S. M., Mehmood, D., Mansoor, K., Iqbal, Z., and Muhammad Kazim',
    venue: 'Information, 15(8), 495',
    url: 'https://doi.org/10.3390/info15080495',
  },
  {
    id: 'pub-7', year: '2024', type: 'Conference paper',
    title: 'Link Prediction and Navigability of Multiplex Energy Networks',
    authors: 'Muhammad Kazim, Harun Pirim, et al.',
    venue: 'ASCE International Conference on Computing in Civil Engineering, July 28-31, 2024',
    url: 'https://arxiv.org/abs/2503.14641',
  },
  {
    id: 'pub-8', year: '2025', type: 'Under review',
    title: 'Network-Integrated Reverse Vaccinology Using Biomni-Prioritized Features and Graph Neural Networks in Flavobacterium',
    authors: 'Muhammad Kazim, F. Farzana, Harun Pirim, L. Hanson, M. Griffin, et al.',
    venue: 'Preprint available at Research Square',
    url: 'https://doi.org/10.21203/rs.3.rs-8107499/v1',
  },
  {
    id: 'pub-9', year: '2026', type: 'Under review',
    title: 'Overhead-Aware Multilayer Graph Learning for Network-Managed Multi-Attack Detection in RPL-Based Low-Power IoT Networks',
    authors: 'Sohail Abbas, Muhammad Kazim, Muhammad Fayaz, and Harun Pirim',
    venue: 'Preprint available at Research Square',
    url: 'https://doi.org/10.21203/rs.3.rs-10795699/v1',
  },
  {
    id: 'pub-10', year: '2026', type: 'Under review',
    title: 'From Prediction to Action: A Controlled Benchmark of Multilayer Graph Embeddings for Substation-Level Predictive Maintenance',
    authors: 'Muhammad Kazim and Harun Pirim',
    venue: 'Preprint available at Research Square',
    url: 'https://doi.org/10.21203/rs.3.rs-9665787/v1',
  },
];

export default publicationsConfig;
